import { Component, OnInit } from "@angular/core";
import { environment } from "src/environments/environment";
import { AdvertisementService } from "../../services/advertisement/advertisement.service";
import { AdvertisementInstance } from "@models/advertisement.model";
import { Router } from "@angular/router";
import { ProductService } from "../../services/product/product.service";
import { ProductAttributes, ProductCategories } from "@models/product.model";

@Component({
    selector: "home-page",
    templateUrl: "./home-page.component.html",
    styleUrls: ["./home-page.component.scss"],
    standalone: false,
})
export class HomePageComponent implements OnInit {
    public bestSellerProducts: ProductAttributes[] = [];

    constructor(
        private router: Router,
        private advertisementService: AdvertisementService,
        private productService: ProductService,
    ) {}

    ngOnInit(): void {
        this.productService
            .getAllActiveProducts(environment.dynamicPagination.pageIndex, 4, "", ProductCategories.BestSeller)
            .subscribe((response) => {
                this.bestSellerProducts = response.rows;
            });
    }
}
